{
  "version": 1,
  "asset_id": "6705e886-6d84-41db-9f0c-c0dfd12801c2",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/6705e886-6d84-41db-9f0c-c0dfd12801c2/lecanto-metal-roof-after-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/6705e886-6d84-41db-9f0c-c0dfd12801c2/lecanto-metal-roof-after-1200w.avif",
  "original_filename": "lecanto-metal-roof-after-1200w.avif",
  "size": 103246,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:47Z"
}
